import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";

import { SellerDocumentUpload } from "../components/seller/SellerDocumentUpload.jsx";
import { AMLStatusDisplay } from "../components/seller/AMLStatusDisplay.jsx";
import { getSellerOnboarding } from "../api/sellerOnboarding.js";

export default function SellerCompliance() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [onboarding, setOnboarding] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    getSellerOnboarding()
      .then((response) => {
        if (!mounted) return;
        setOnboarding(response);
        setLoading(false);
      })
      .catch((err) => {
        if (!mounted) return;
        setError(err.message || "Unable to load onboarding");
        setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <main className="min-h-screen bg-neutral-950 text-white p-6 flex items-center justify-center">
        <div className="text-center text-sm text-white/70">Loading compliance…</div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="min-h-screen bg-neutral-950 text-white p-6 flex items-center justify-center">
        <div className="max-w-md text-center space-y-4">
          <p className="text-sm text-red-300">{error}</p>
          <button
            onClick={() => navigate("/seller")}
            className="rounded-xl bg-white text-black px-4 py-2 text-sm font-medium hover:bg-white/90"
          >
            Back to seller start
          </button>
        </div>
      </main>
    );
  }

  if (!onboarding?.id) {
    return <Navigate to="/seller" replace />;
  }

  return (
    <main className="min-h-screen bg-neutral-950 text-white p-6">
      <div className="max-w-4xl mx-auto space-y-8">
        <header className="space-y-2">
          <p className="text-xs uppercase tracking-[0.35em] text-white/50">Compliance</p>
          <h1 className="text-3xl font-semibold">Upload AML documents</h1>
          <p className="text-sm text-white/70">
            Complete your compliance checks to keep your sale on track.
          </p>
        </header>

        <AMLStatusDisplay onboardingId={onboarding.id} showDetails className="w-full" />

        <SellerDocumentUpload
          onboardingId={onboarding.id}
          onUploadsComplete={() => {
            // no-op; AML status widget refreshes every 30s
          }}
        />
      </div>
    </main>
  );
}
